import React, {Fragment, useContext} from 'react'
import {Stack} from 'react-bootstrap'
import {useNavigate} from 'react-router-dom'
import {KTIcon} from '../../../../../_metronic/helpers'
import {formatDateToDMY} from '../../../../helpers/dateFunctions'
import {ModernPagination} from '../../../../shared/ModernPagination'
import SortableTableHeader from '../../../../shared/SortableTableHeader'
import {CustomTooltip} from '../../../generales_component/CustomTooltip'
import {AprobacionAnyContext} from '../AprobacionAnyContext'

const iconsData = [
  {
    iconName: 'verify',
    title: 'Borrador',
    stateName: 'borrador',
    color: '#f39c12',
  },
  {
    iconName: 'security-user',
    title: 'Enviado',
    stateName: 'completado',
    color: '#2ecc71',
  },
  {
    iconName: 'security-user',
    title: 'Pendiente',
    stateName: 'pendiente',
    color: '#3c50e7',
  },
]

export const AprobacionAnyBody: React.FC = () => {
  const {page, setPage, totalPages, sortBy, setSortBy, packages, permissions, loading} =
    useContext(AprobacionAnyContext)
  const handlePageChange = (page: number) => {
    setPage(page)
  }
  const navigate = useNavigate()

  const handleSort = (columnName: string, sortDirection: string) => {
    setSortBy({columnName, sortDirection})
  }

  const handleView = (id: any) => {
    navigate(`/seguimiento/aprobacion-any/detalle/${id}`)
  }

  return (
    <>
      <div className='table-responsive'>
        <table className='table align-middle table-row-bordered fs-6 table-hover'>
          <thead>
            <tr className='text-start fw-bolder fs-7 text-uppercase gs-0 bg-primary text-white'>
              <SortableTableHeader
                label='Proceso'
                columnName='idProceso'
                handleSort={handleSort}
                activeColumn={sortBy.columnName}
                labelStyle={{color: '#ffffff'}}
              />
              <td className='text-start p-3'>Unidad</td>
              <td className='text-start'>Codigo</td>
              <SortableTableHeader
                label='Nombre de Paquete'
                columnName='nombre'
                handleSort={handleSort}
                activeColumn={sortBy.columnName}
                labelStyle={{color: '#ffffff'}}
              />
              <SortableTableHeader
                label='Fecha'
                columnName='createdAt'
                handleSort={handleSort}
                activeColumn={sortBy.columnName}
                labelStyle={{color: '#ffffff'}}
              />

              <td className='text-start' title='Documentos pendientes aprobacion'>
                Pendientes
              </td>
              <td className='text-start' title='Documentos aprobados'>
                Aprobados
              </td>
              <td className='text-end p-3'>Opciones</td>
            </tr>
          </thead>
          <tbody className='text-gray-600 fw-bold'>
            {loading ? (
              <tr>
                <td colSpan={7}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    Cargando...
                  </div>
                </td>
              </tr>
            ) : packages.length > 0 ? (
              packages?.map((item: any) => {
                return (
                  <Fragment key={item._id}>
                    <tr>
                      <td className='text-start min-w-200px p-2'>{item.idProceso.nombre}</td>
                      <td className='text-start min-w-250px p-3'>
                        {item.unidad && item.unidad.length > 0
                          ? item.unidad.map((u: any) => u.DesUnid).join(', ')
                          : 'Sin Unidad'}
                      </td>
                      <td className='text-start min-w-150px p-3'>{item.codigo ?? 'Sin Codigo'}</td>
                      <td className='text-start min-w-250px p-2'>{item.nombre}</td>
                      <td className='text-start min-w-150px p-2'>
                        {formatDateToDMY(item.createdAt)}
                      </td>

                      <td className='text-start min-w-100px p-2'>
                        {item?.docsPendingToAprove ?? 0}
                      </td>
                      <td className='text-start min-w-100px p-2'>{item?.docsApproved ?? 0}</td>

                      <td className='text-end d-flex align-self-end justify-content-end p-1'>
                        {item.deniedDocs > 0 && (
                          <CustomTooltip
                            className='btn btn-icon btn-danger btn-sm'
                            icon='information-4'
                            placement='top'
                            children={`Hay ${item.deniedDocs} documentos rechazados dentro de los niveles de aprobación`}
                          />
                        )}
                        <Stack direction='horizontal' gap={1}>
                          {permissions.includes('Ver detalle') && (
                            <button
                              className='btn btn-icon btn-bg-light btn-active-color-primary btn-sm'
                              title='Ver detalle'
                              onClick={() => handleView(item._id)}
                            >
                              <KTIcon iconName='eye' className='fs-3' />
                            </button>
                          )}
                        </Stack>
                      </td>
                    </tr>
                  </Fragment>
                )
              })
            ) : (
              <tr>
                <td colSpan={5}>
                  <div className='d-flex text-center w-100 align-content-center justify-content-center'>
                    No tienes documentos a aprobar
                  </div>
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <ModernPagination
        totalPages={totalPages}
        currentPage={page}
        isLoading={false}
        onPageChange={handlePageChange}
        siblings={5}
      />
    </>
  )
}
